import * as React from "react";

const CloudDownloadIcon = ({
    height = "25px",
    width = "22px",
    color = "#636F7C",
    ...props
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        {/* Cloud */}
        <path
            fill={color}
            d="M19 18H6a4 4 0 010-8 5 5 0 019.7-1.5A3.5 3.5 0 0119 18z"
        />

        {/* Download Arrow */}
        <path
            fill="#FFFFFF"
            d="M12 10v4m0 0l-2-2m2 2l2-2"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default CloudDownloadIcon;